<template>
  <b-row class="w-100 m-0">
    <b-col :class="`p-0 ${is_avaible_to_editing || data_header.is_in_sidebar ? 'col-12 col-lg-8' : 'col-12' }`">
      <div class="d-flex flex-wrap w-100 title-description-edit position-relative">
        <h2 
          :class="`${is_avaible_to_editing || data_header.is_in_sidebar ? 'col-12' : 'col-lg-12' } p-0 w-100 text-left color-text-title`"  
          v-if="!loading"
        >
          {{ data_header.title }}
        </h2>
        <div v-else class="w-100">
          <b-skeleton animation="fade" width="100%"></b-skeleton>
          <b-skeleton animation="fade" width="85%"></b-skeleton>
        </div>

        <b-link
          @click="redirectMembership()"
          :class="`${is_avaible_to_editing || data_header.is_in_sidebar ? 'col-12' : 'col-lg-12' } p-0 w-100 text-left text-muted my-1`"
          v-if="!is_free_proposal"
        >
          <div class="d-flex align-items-center">
            <div class="badge-redirect"></div>
            {{ $t('creator.proAccount') }}
          </div>
        </b-link>


        <p 
          :class="`${is_avaible_to_editing || data_header.is_in_sidebar ? 'col-12' : 'col-lg-12' } p-0 w-100 text-left mt-1 avenir-medium color-text-description`" 
          v-if="!loading" 
          v-html="data_header.description"
        ></p>
        
        <div class="w-100 mt-2" v-else>
          <b-skeleton animation="fade" width="100%"></b-skeleton>
          <b-skeleton animation="fade" width="85%"></b-skeleton>
          <b-skeleton animation="fade" width="55%"></b-skeleton>
          <b-skeleton animation="fade" width="70%"></b-skeleton>
          <b-skeleton animation="fade" width="100%"></b-skeleton>
          <b-skeleton animation="fade" width="55%"></b-skeleton>
          <b-skeleton animation="fade" width="70%"></b-skeleton>
          <b-skeleton animation="fade" width="100%"></b-skeleton>
        </div>

        <div 
          :class="`${!data_header.description && !data_header.title ? 'add-option-action' : 'background-button-edit'} box-edit`" 
          @click="$emit('edit_proposal', 'title_description')" 
          v-if="is_avaible_to_editing && !data_header.is_in_sidebar && !loading"
        >
          <h5 class="m-0 animation-opacity-words">{{ $t('creator.editTitle') }}</h5>
        </div>
      </div>
    </b-col>
    <b-col 
      class="d-none d-lg-block col-4 p-0 pl-2" 
      v-if="!loading && is_avaible_to_editing && !data_header.is_in_sidebar"
    >
      <div class="bubble-edit" @click="$emit('edit_proposal', 'title_description')">
        <feather-icon icon="Edit2Icon"></feather-icon>
        <span class="ml-05 avenir-bold">{{ $t('creator.titleDesc') }}</span>
      </div>
    </b-col>

    <modal-login :open_modal="open_modal_login" :key="update_modal_login"></modal-login>
  </b-row>
</template>

<script>
import {
  BCol,
  BRow,
  BLink,
  BSkeleton,
} from 'bootstrap-vue';
import { nameNetworks, getFormat } from '@/libs/utils/formats';
import { getUserData } from '@/libs/utils/user';
import profile_services from '@/services/profile';
import service_others from '@/services/others';

export default {
  name: 'TitleAndDescriptionPreview',
  components: {
    BCol,
    BRow,
    BLink,
    BSkeleton,
    ModalLogin: () => import('@/views/components/modal/ModalLogin.vue')
  },
  props: {
    data_header: {
      type: Object,
      default: () => ({})
    },
    is_avaible_to_editing: {
      type: Boolean,
      default: false
    },
    is_free_proposal: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nameNetworks,
      getFormat,
      analytics_overview: null,
      open_modal_login: false,
      update_modal_login: false,
    }
  },
  computed: {
    is_brand() {
      return getUserData() && getUserData().main_group.name !== 'creator'
    },
    is_free() {
      return getUserData() && getUserData().current_plan.name === 'Free'
    },
    has_session() {
      return getUserData()
    },
    isAvaibleToAnalize() {
      const networks_avaible = ['instagram', 'youtube', 'tiktok', 'twitch', 'twitter']
      if (!this.data_header.user_network) return false;
      
      return networks_avaible.includes(this.data_header.user_network.network)
    },
  },
  created() {
    if (this.has_session && this.isAvaibleToAnalize) {
      this.getReportNetwork();
    }
  },
  methods: {
    redirectMembership() {
      if (!this.has_session || this.is_free) {
        const url = this.$router.resolve({ 
          name: 'pages-account-setting', 
          params: { section: 'membership' } 
        }).href;
        window.open(url, '_blank');
      }
    },
    getReportNetwork() {
      if (this.is_brand) {
        service_others.getVisitedProfiles(
          this.data_header.user_network.network, 
          this.data_header.user_network.username
        ).then((response) => {
          if (response.results.length > 0) {
            this.assignMetricsFromUserNetwork();
          }
        })
      } else {
        profile_services.canUnlockOrPayProfile(this.data_header.user_network.uuid).then((response) => {
          if (response.already_viewed) {
            this.assignMetricsFromUserNetwork()
          }
        })
      }
    },
    assignMetricsFromUserNetwork() {
      this.analytics_overview = {
        followers: getFormat(this.data_header.user_network.followers),
        er: this.data_header.user_network.er,
      } 
    },
  }
}
</script>

<style scoped lang="scss">
.grid-two  {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;

  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr;
  }
}
.badge-redirect {
  width: 13px;
  height: 13px;
  background: linear-gradient(225deg, #068eb5 0%, #9b51e0 47%);
  border-radius: 2px;
  margin-right: 10px
}
.border-box-analytics {
  border: 1px solid #eaeaea;
  border-radius: 1em;
  padding: 0.5em;
  box-shadow: 0rem 0.375rem 0.75rem rgb(108 117 125 / 8%);
  text-align: left;
  p {
    font-family: "avenir-medium";
    font-size: 11.5px;
    color: #6c757d;
  }
}

.color-text-title {
  color: #191919
}
.color-text-description {
  color: #1e2124;
  white-space: pre-line;
}
.box-edit {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  border-radius: 0.55em;
  cursor: pointer;
}
.background-button-edit {
  background-color: transparent;
  .animation-opacity-words {
    opacity: 0;
    color: white !important;
  }
  
}
.add-option-action {
  border: 2px dashed #2969C8;
  color: #2969C8;
}
.add-option-action:hover {
  border: 2px solid #2969C8;
}
.title-description-edit:hover .background-button-edit {
  background-color: #3b8da888;
  transition: all 500ms;
  cursor: pointer;
  backdrop-filter: blur(10px);
}
.title-description-edit:hover .animation-opacity-words {
  opacity: 1;
  transition: all 500ms;
}
.title-description-edit:not(:hover) .animation-opacity-words,
.title-description-edit:not(:hover) .background-button-edit {
  transition: all 500ms;
}
.title-description-edit {
  padding: 1em 0 0 0;
}
.bubble-edit {
  text-align: left;
  padding: 1em;
  color: #3b8DA8;
  background: #E6f2f6;
  border-radius: 1em;
  cursor: pointer;
  position: sticky;
  position: -webkit-sticky;
  top: 12em;
}
.bubble-edit:hover {
  transition: all 300ms;
  background: #3b8da82f;
}
.bubble-edit:before {
  border: 10px solid #E6f2f6;
  content: '';
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  transform: rotate(90deg);
  left: -19px;
}
.bubble-edit:hover:before {
  border: 10px solid #3b8da82f;
  content: '';
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  transform: rotate(90deg);
  left: -19px;
  transition: all 300ms;
}
.ml-05 {
  margin-left: 0.55em;
}
</style>
